






































































import { Vue, Component } from "vue-property-decorator"
import api from "../honcierge-api"

@Component
export default class Login extends Vue {
  private email = ""
  private password = ""
  private errorMessage = ""
  private async login() {
    try {
      const loginResponse = await api.login(this.email, this.password)
      const authToken = loginResponse.data.jwt
      const adminUserResponse = await api.getAdminUserByAuthToken(authToken)
      const adminUser = adminUserResponse.data.adminUser
      const redirectTo = this.$route.query.redirect
      await this.$store.dispatch("login", { authToken, adminUser })
      if (redirectTo && !Array.isArray(redirectTo)) {
        this.$router.push({ path: redirectTo })
      } else {
        this.$router.push({ path: "/" })
      }
    } catch {
      this.errorMessage = "認証に失敗しました"
      this.$store.dispatch("logout")
    }
  }
}
